import React, { Component } from 'react';
import { View, Button, PageContainer, Card, Loc } from '../UIElements/All.js';
import { Colors, ButtonColors } from '../Managers/ThemeManager.js';
import { close } from '../Managers/LSLoyaltyAPI.js';

export default class MissingSignature extends Component {
  constructor(props) {
    super(props);

    this.state = this.props.location.state;
    this.returnURL = this.props.location.state.urlInputs.returnURL;
  }

  render() {
    return (
      <PageContainer
        urlInputs={this.state.urlInputs}
        ref={(a) => { this._pageContainer = a; }}
      >
        <Card
          style={{
            position: 'relative',
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'stretch',
            flex: -1,
            height: 220,
            backgroundColor: Colors.background2,
            borderRadius: 4,
            flexDirection: 'column',
            color: Colors.text1,
            fontSize: 24,
            padding: 12,
            margin: 12,
          }}
        >
          <View style={{ flex: 1 }} />

          <View
            style={{
              flex: -1,
              margin: 8,
              textAlign: 'center',
              alignItems: 'center',
              fontWeight: 'bold',
              justifyContent: 'center',
            }}
          >
            <Loc locKey="INVALID_LOGIN_CREDENTIALS_TITLE" />
          </View>
          <View
            style={{
              flex: -1,
              fontSize: 18,
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Loc locKey="INVALID_LOGIN_CREDENTIALS_BODY" />
          </View>

          <View style={{ flex: 1 }} />

          {typeof this.props.urlInputs !== 'undefined' ? (
            <Button
              onPress={() => close(this.state.urlInputs)}
              type={1}
              colors={ButtonColors}
              style={{ alignSelf: 'center', margin: 12 }}
            >
              {typeof this.state.closeButtonTitle === 'undefined' ? (
                <Loc locKey="BACK_TO_PAY_BUTTON" />
              ) : (
                this.state.closeButtonTitle
              )}
            </Button>
          ) : null}

          <View style={{ flex: 1 }} />
        </Card>
      </PageContainer>
    );
  }
}
